"use strict";
exports.__esModule = true;
exports.ProductionItemPieceBuilder = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var DesignerAssets_1 = require("../base/DesignerAssets");
var ProductionItemPieceBuilder = /** @class */ (function () {
    function ProductionItemPieceBuilder(item, piece) {
        this.item = item;
        this.itemAssetsBuilder = DesignerAssets_1.DesignerAssetsBuilder.initialiseWithEmptyAssets().addPiece(piece);
    }
    ProductionItemPieceBuilder.initialise = function (quantity, piece, pieceReference, inventoryReference) {
        return new ProductionItemPieceBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            quantity: quantity,
            pieceReference: pieceReference,
            inventoryReference: inventoryReference,
            pieceSides: [],
            engravings: []
        }, piece);
    };
    ProductionItemPieceBuilder.prototype.addEngravingWithText = function (engraving, textFont) {
        if (engraving.text === undefined)
            throw new core_common_domain_1.Exception("Cannot add an engraving with text. Text object undefined in engraving " + JSON.stringify(engraving));
        this.item.engravings.push(engraving);
        this.itemAssetsBuilder.addFont(textFont);
        return this;
    };
    ProductionItemPieceBuilder.prototype.addEngravingWithSymbol = function (engraving, symbol) {
        if (engraving.symbol === undefined)
            throw new core_common_domain_1.Exception("Cannot add an engraving with symbol. Symbol object undefined in engraving " + JSON.stringify(engraving));
        this.item.engravings.push(engraving);
        this.itemAssetsBuilder.addSymbol(symbol);
        return this;
    };
    ProductionItemPieceBuilder.prototype.addProductionPlanPieceSide = function (side, image, vector) {
        if (this.item.pieceSides.find(function (ps) { return ps.side === side; }) !== undefined)
            throw new core_common_domain_1.Exception("Cannot add side " + side + " because it already exists in the piece");
        this.item.pieceSides.push({
            side: side,
            image: image,
            vector: vector
        });
        return this;
    };
    ProductionItemPieceBuilder.prototype.build = function () {
        return { item: this.item, assets: this.itemAssetsBuilder.build() };
    };
    return ProductionItemPieceBuilder;
}());
exports.ProductionItemPieceBuilder = ProductionItemPieceBuilder;
